const MAX_NOTE_LENGTH = 2000;

const NOTE_ACTION = {
  EDIT: 'EDIT',
  ADD: 'ADD',
  VIEW: 'VIEW',
};

const EXTENSION_TO_MIME = {
  pdf: 'application/pdf',

  jpeg: 'image/jpeg',
  jpg: 'image/jpg',
  png: 'image/png',
  gif: 'image/gif',
  doc: 'application/msword',
  heic: 'image/heic',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv',
  txt: 'text/plain',
};

const ATTACHMENT_TYPES = [
  {
    label: 'Proof Of Purchase',
    value: 'PROOF_OF_PURCHASE',
  },
  {
    label: 'Product Image',
    value: 'PRODUCT_IMAGE',
  },
  {
    label: 'Warranty Document',
    value: 'WARRANTY_DOCUMENT',
  },
  {
    label: 'Other',
    value: 'OTHER',
  },
];

const ATTACHMENT_PRIVACY = [
  {
    label: 'INTERNAL',
    value: 'Internal',
  },
  {
    label: 'EXTERNAL',
    value: 'External',
  },
];

export {
  NOTE_ACTION,
  EXTENSION_TO_MIME,
  ATTACHMENT_TYPES,
  ATTACHMENT_PRIVACY,
  MAX_NOTE_LENGTH,
};
